import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FILTER_TYPE_META } from '../../../../constants/reviewEntriesFilterConfig'
import { ReviewEntriesFilterType } from '../../../../enums/reviewEntriesFilterType'
import type { ReviewEntriesFiltersState } from '../../../../types/reviewEntriesFilters'
import type { ReviewEntryTableRow } from '../../../../types/reviewEntryTableRow'
import { formatReviewEntriesFilterPreview } from '../../../../utils/formatReviewEntriesFilterPreview'
import { getSupplierOptionsFromRows } from '../../../../utils/getReviewEntriesFilterOptions'
import { MultiSelectFilterBody } from '../../elements/MultiSelectFilterBody'
import { ReviewEntriesFilterChipShell } from '../../ReviewEntriesFilterChipShell'

interface SupplierFilterChipProps {
  filters: ReviewEntriesFiltersState
  rows: ReviewEntryTableRow[]
  shouldAutoOpen: boolean
  onAutoOpenHandled: () => void
  onDelete: () => void
  onReset: () => void
  onChange: (values: string[]) => void
}

export const SupplierFilterChip = ({
  filters,
  rows,
  shouldAutoOpen,
  onAutoOpenHandled,
  onDelete,
  onReset,
  onChange,
}: SupplierFilterChipProps): ReactElement => {
  const { t } = useTranslation()
  const selectedValues = filters.supplier ?? []
  const options = useMemo(() => getSupplierOptionsFromRows(rows), [rows])
  const label = t(FILTER_TYPE_META[ReviewEntriesFilterType.Supplier].labelKey)

  return (
    <ReviewEntriesFilterChipShell
      isActive={selectedValues.length > 0}
      label={label}
      onAutoOpenHandled={onAutoOpenHandled}
      onDelete={onDelete}
      onReset={onReset}
      shouldAutoOpen={shouldAutoOpen}
      type={ReviewEntriesFilterType.Supplier}
      valuePreview={formatReviewEntriesFilterPreview(ReviewEntriesFilterType.Supplier, filters)}
    >
      <MultiSelectFilterBody
        noResultsLabel={t('review_entries.filters.supplier.no_results')}
        onChange={onChange}
        options={options}
        searchPlaceholder={t('review_entries.filters.supplier.search_placeholder')}
        selectedValues={selectedValues}
      />
    </ReviewEntriesFilterChipShell>
  )
}
